export const getVoiceRecordingFileName = (
	mimeType = '',
	fallback = 'voice.webm',
) => {
	const type = mimeType.toLowerCase();

	if (type.includes('mp4') || type.includes('m4a')) {
		return 'voice.m4a';
	}

	if (type.includes('ogg')) {
		return 'voice.ogg';
	}

	if (type.includes('wav')) {
		return 'voice.wav';
	}

	if (type.includes('mpeg') || type.includes('mp3')) {
		return 'voice.mp3';
	}

	if (type.includes('aac')) {
		return 'voice.aac';
	}

	if (type.includes('webm')) {
		return 'voice.webm';
	}

	return fallback;
};
